import { cva } from "class-variance-authority";

export const buttonVariants = cva(
  [
    "inline-flex items-center justify-center whitespace-nowrap rounded border font-medium",
    "transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2",
    "disabled:cursor-not-allowed disabled:border-gray-200 disabled:bg-gray-200 disabled:text-gray-400 disabled:hover:border-gray-200 disabled:hover:bg-gray-200 disabled:hover:text-gray-400",
  ],
  {
    variants: {
      pattern: {
        primary: "",
        secondary: "",
        inverse: "",
      },
      size: {
        tiny: "h-6 px-3 text-xs",
        small: "h-8 px-4 text-sm",
        medium: "h-10 px-4 text-sm leading-6",
      },
      variant: {
        filled: "",
        outlined: "",
        ghost: "border-none bg-transparent shadow-none",
      },
      isInline: {
        true: "w-auto",
        false: "w-full",
      },
    },
    compoundVariants: [
      // FILLED VARIANTS
      {
        pattern: "primary",
        variant: "filled",
        className:
          "border-blue-500 bg-blue-500 text-white hover:border-blue-600 hover:bg-blue-600 focus-visible:ring-blue-500 active:border-blue-700 active:bg-blue-700",
      },
      {
        pattern: "secondary",
        variant: "filled",
        className:
          "border-none bg-white text-gray-900 hover:border-gray-300 hover:bg-gray-100 focus-visible:ring-gray-500 active:bg-gray-200",
      },
      {
        pattern: "inverse",
        variant: "filled",
        className:
          "border-white bg-white text-gray-900 hover:border-gray-100 hover:bg-gray-100 focus-visible:ring-gray-500 active:bg-gray-200 disabled:border-gray-200 disabled:bg-gray-200 disabled:hover:border-gray-200 disabled:hover:bg-gray-200",
      },

      // OUTLINED VARIANTS
      {
        pattern: "primary",
        variant: "outlined",
        className:
          "border-gray-300 bg-transparent text-blue-500 hover:bg-blue-100 focus-visible:ring-blue-500 active:bg-blue-200 disabled:border-gray-300 disabled:hover:border-gray-300",
      },
      {
        pattern: "secondary",
        variant: "outlined",
        className:
          "border-gray-300 bg-transparent text-gray-900 hover:bg-gray-300 focus-visible:ring-gray-500 active:bg-gray-400 disabled:border-gray-300 disabled:hover:border-gray-300",
      },
      {
        pattern: "inverse",
        variant: "outlined",
        className:
          "border-gray-500 bg-transparent text-white hover:border-gray-500 hover:bg-gray-700 focus-visible:ring-gray-500 active:bg-gray-800 disabled:border-gray-700 disabled:bg-transparent disabled:text-gray-650 disabled:hover:border-gray-700 disabled:hover:bg-transparent disabled:hover:text-gray-650",
      },

      // GHOST VARIANTS
      {
        pattern: "primary",
        variant: "ghost",
        className:
          "bg-transparent text-blue-500 hover:bg-blue-100 focus-visible:ring-blue-500 active:bg-blue-200 disabled:bg-transparent disabled:hover:bg-transparent",
      },
      {
        pattern: "secondary",
        variant: "ghost",
        className:
          "bg-transparent text-gray-900 hover:bg-gray-100 focus-visible:ring-gray-500 active:bg-gray-400 disabled:bg-transparent disabled:hover:bg-transparent",
      },
      {
        pattern: "inverse",
        variant: "ghost",
        className:
          "bg-transparent text-white hover:bg-gray-700 focus-visible:ring-gray-500 active:bg-gray-800 disabled:bg-transparent disabled:text-gray-650 disabled:hover:bg-transparent disabled:hover:text-gray-650",
      },
    ],
    defaultVariants: {
      pattern: "primary",
      size: "medium",
      variant: "filled",
      isInline: false,
    },
  }
);
